import { BrowserRouter, Routes, Route } from "react-router-dom";
import React, { useEffect, useState,useRef } from "react";

import { Box } from '@mui/material';

import { ChannelDetail, VideoDetail, SearchFeed, Navbar, Feed,Side,Shorts, ShortVideo,News,Sports,Podcast,Education,Gaming,Music } from './components';
import { Stack } from "@mui/system";
// import  from "./components/Shorts";
// import Side from "./components";
// import Navbar from './components/Navbar';
// import Feed from "./components/Feed"

const App = () => {
  const [sidebar, setSidebar] = useState(false);
  const menuIcon = useRef(null)
  const [selectedCategory, setSelectedCategory] = useState("Home");
  const showSidebar = (e) => {
    // console.log(sidebar)
    console.log(sidebar)


    setSidebar(!sidebar)
    // if (menuIcon.current.contains(e.target)){
      
    // }
    
  };

  return(
  <BrowserRouter>
    <Box sx={{ height:"100vh",backgroundColor: '#000', overflow: 'hidden'}}>
      <Navbar setSelectedCategory={setSelectedCategory} menuIcon={menuIcon} showSidebar = {showSidebar} />
        <Stack sx={{ flexDirection: { sx: "column", md: "row" } }}>
          
        <Box  sx={{ height: { sx: "auto", md: "92vh" },  px: { sx: 0, md: 2 } }}>
              
              {/* <Sidebar selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory} /> */}
              <>
                <Side selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory} menuIcon={menuIcon} sidebar={sidebar} setSidebar = {setSidebar}/>
                {/* <Sidebar sidebar={sidebar}/> */}
              </>
              
              {/* <Typography className="copyright" variant="body2" sx={{ mt: 1.5, color: "#fff", }}>
                Copyright © 2022 JSM Media
              </Typography> */}
            </Box>
          <Routes>
            


            <Route exact path='/' element={<Feed setSelectedCategory={setSelectedCategory}/>} />
            {/* <Route path='/:selectedCategory' element={<Shorts />} /> */}
            <Route path='/Shorts' element={<Shorts />} />
            <Route path='/Shorts/:id' element={<ShortVideo />} />
            <Route path='/Education' element={<Education />} />
            <Route path='/Sports' element={<Sports />} />
            <Route path='/Podcast' element={<Podcast />} />
            <Route path='/Music' element={<Music />} />
            <Route path='/News' element={<News />} />
            <Route path='/Gaming' element={<Gaming />} />

            <Route path='/video/:id' element={<VideoDetail />} />
            <Route path='/channel/:id' element={<ChannelDetail />} />
            <Route path='/search/:searchTerm' element={<SearchFeed />} />
          </Routes>

          </Stack >
        

      

      
    </Box>
  </BrowserRouter>
)};

export default App;